import { hotRank } from '@/mocks/homeData';

const rankTone = (i: number) => {
  if (i === 0) return 'bg-accent-500 text-background-50';
  if (i === 1) return 'bg-accent-400 text-background-50';
  if (i === 2) return 'bg-accent-300 text-foreground-800';
  return 'bg-secondary-200 text-foreground-700';
};

const deltaIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  down: 'ri-arrow-down-line text-foreground-400',
  flat: 'ri-subtract-line text-foreground-300',
};

export default function HotRank() {
  return (
    <aside className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
      <div className="mb-4">
        <p className="text-xs font-semibold tracking-[0.2em] text-accent-600">TOP 10 · 热度榜</p>
        <h3 className="mt-1 font-heading text-xl font-black text-foreground-950 md:text-2xl">今日吃瓜热度榜</h3>
      </div>

      <ol className="flex-1 divide-y divide-background-200">
        {hotRank.map((r) => (
          <li key={r.id} className="flex items-center gap-3 py-2.5">
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${rankTone(r.rank - 1)}`}
            >
              {r.rank}
            </span>
            <a
              href="#digest"
              className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-800 transition-colors hover:text-primary-700"
            >
              {r.title}
            </a>
            <span className="flex items-center gap-1.5">
              <span className="text-xs font-semibold text-foreground-600">{r.heat}</span>
              <span className={`flex h-4 w-4 items-center justify-center ${deltaIcon[r.delta]}`}>
                <i className={`${deltaIcon[r.delta]} text-sm`} aria-hidden="true"></i>
              </span>
            </span>
          </li>
        ))}
      </ol>

      <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
        <span className="inline-flex items-center gap-1">
          <i className="ri-flashlight-line text-accent-600" aria-hidden="true"></i>
          每小时滚动更新
        </span>
        <span className="inline-flex items-center gap-1">
          <i className="ri-refresh-line" aria-hidden="true"></i>
          更新于 14:26
        </span>
      </div>
    </aside>
  );
}